import axiosIns from "@/api/axios";

export const GET_LIST_ATTENDANCE_IDP_STRUCTURED_LEARNING = (query) => {
  let url = "/idp/structured-learnings/attendances";

  if (query && Object.keys(query).length > 0) {
    const params = new URLSearchParams(query).toString();
    url += `?${params}`;
  }

  return axiosIns.get(url);
};

export const GET_DETAIL_EVENT_ATTENDANCE_IDP_STRUCTURED_LEARNING = (payload) => {
  const { id } = payload;

  let url = `/idp/structured-learnings/attendances/${id}/event`;

  return axiosIns.get(url);
};

export const GET_DETAIL_ATTENDANCE_IDP_STRUCTURED_LEARNING = (payload) => {
  const { id } = payload;

  let url = `/idp/structured-learnings/attendances/${id}/detail`;

  return axiosIns.get(url);
};

export const SUBMIT_ATTENDANCE_IDP_STRUCTURED_LEARNING = (id) => {
  let url = `/idp/structured-learnings/attendances/${id}/submit`;

  return axiosIns.post(url);
};
